import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {EyeIcon, PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {Site} from "../../../types/Site";

// Types ----

type SiteContextMenuProps = {
  site: Site
  onDeleteSite: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function SiteContextMenu({deleteDisabled, onDeleteSite, editDisabled, site, viewDisabled, position = 'right'}: SiteContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewSite() {
    void navigate(`/sites/${site.id}`)
  }

  function editSite() {
    void navigate(`/sites/${site.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('sites:read') &&
        <DropdownItem name="View" icon={EyeIcon} onClick={viewSite} disabled={!!viewDisabled}/>
      }

      {auth.can('sites:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editSite} disabled={!!editDisabled}/>
      }

      {auth.can('sites:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteSite} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default SiteContextMenu;